import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ButtonModule } from '../buttons/button.module';
import { CopyTextComponent } from './copy-text.component';

@NgModule({
  declarations: [CopyTextComponent],
  imports: [CommonModule, ButtonModule],
  exports: [CopyTextComponent],
})
export class CopyTextModule {}
